module.exports = __webpack_public_path__ + "static/media/below-threshold.a9987cef.svg";